export default {
	attributes: {
		design: 'plain',
		columns: 2,
		columns1: 50,
		columns2: 50,
		uniqueClass: 'ugb-48fe2b1',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
		showBlockTitle: false,
		blockTitleLineHeightUnit: 'em',
		blockTitleTabletLineHeightUnit: 'em',
		blockTitleMobileLineHeightUnit: 'em',
		showBlockDescription: false,
		blockDescriptionLineHeightUnit: 'em',
		blockDescriptionTabletLineHeightUnit: 'em',
		blockDescriptionMobileLineHeightUnit: 'em',
	},
	innerBlocks: [
		{
			clientId: 'd7efdd61-2a2e-47ae-90ae-8896a3855043',
			name: 'ugb/column',
			isValid: true,
			validationIssues: [

			],
			originalContent: '<div class="wp-block-ugb-column ugb-column ugb-86df09f ugb-column--design-basic ugb-main-block"><div class="ugb-inner-block"><div class="ugb-block-content"><div class="ugb-column__item ugb-86df09f-column-wrapper"><div class="ugb-column__content-wrapper"></div></div></div></div></div>',
			attributes: {
				design: 'basic',
				columnBackgroundCustomSizeUnit: '%',
				columnTabletBackgroundCustomSizeUnit: '%',
				columnMobileBackgroundCustomSizeUnit: '%',
				uniqueClass: 'ugb-86df09f',
				hideDesktop: false,
				hideTablet: false,
				hideMobile: false,
			},
			innerBlocks: [
				{
					clientId: 'f9424a9c-6505-4b24-bba7-5f47154f06ee',
					name: 'ugb/text',
					isValid: true,
					validationIssues: [

					],
					originalContent: '<div class="wp-block-ugb-text ugb-text ugb-b4acf03 ugb-text--design-plain ugb-text--columns-1 ugb-main-block"><div class="ugb-inner-block"><div class="ugb-block-content"><div class="ugb-text__text-wrapper"><div class="ugb-text__text"><p class="ugb-text__text-1">Description for this block. Use this space for describing your block. Any text will do. Description for this block. You can use this space for describing your block.</p></div></div></div></div></div>',
					attributes: {
						design: 'plain',
						columns: 1,
						reverseTitle: false,
						alignment: 'center',
						showColumnRule: false,
						showTitle: false,
						titleLineHeightUnit: 'em',
						titleTabletLineHeightUnit: 'em',
						titleMobileLineHeightUnit: 'em',
						showSubtitle: false,
						subtitleLineHeightUnit: 'em',
						subtitleTabletLineHeightUnit: 'em',
						subtitleMobileLineHeightUnit: 'em',
						subtitleColor: '',
						subtitleOnTop: false,
						text1: 'Description for this block. Use this space for describing your block. Any text will do. Description for this block. You can use this space for describing your block.',
						textLineHeightUnit: 'em',
						textTabletLineHeightUnit: 'em',
						textMobileLineHeightUnit: 'em',
						uniqueClass: 'ugb-b4acf03',
						hideDesktop: false,
						hideTablet: false,
						hideMobile: false,
						showBlockBackground: false,
						blockBackgroundBackgroundCustomSizeUnit: '%',
						blockBackgroundTabletBackgroundCustomSizeUnit: '%',
						blockBackgroundMobileBackgroundCustomSizeUnit: '%',
						topSeparatorDesign: 'wave-1',
						bottomSeparatorDesign: 'wave-1',
					},
				},
			],
		},
		{
			clientId: '35a9a6fb-fa22-45f0-8bd8-b55118218bc5',
			name: 'ugb/column',
			isValid: true,
			validationIssues: [

			],
			originalContent: '<div class="wp-block-ugb-column ugb-column ugb-9278b23 ugb-column--design-basic ugb-main-block"><div class="ugb-inner-block"><div class="ugb-block-content"><div class="ugb-column__item ugb-9278b23-column-wrapper"><div class="ugb-column__content-wrapper"></div></div></div></div></div>',
			attributes: {
				design: 'basic',
				columnBackgroundCustomSizeUnit: '%',
				columnTabletBackgroundCustomSizeUnit: '%',
				columnMobileBackgroundCustomSizeUnit: '%',
				uniqueClass: 'ugb-9278b23',
				hideDesktop: false,
				hideTablet: false,
				hideMobile: false,
			},
			innerBlocks: [
				{
					clientId: '11a58c75-44ce-47ec-ba4c-12081a5f7bb3',
					name: 'ugb/text',
					isValid: true,
					validationIssues: [

					],
					originalContent: '<div class="wp-block-ugb-text ugb-text ugb-6e7c623 ugb-text--design-plain ugb-text--columns-1 ugb-main-block"><div class="ugb-inner-block"><div class="ugb-block-content"><div class="ugb-text__text-wrapper"><div class="ugb-text__text"><p class="ugb-text__text-1">Description for this block. Use this space for describing your block. Any text will do. Description for this block. You can use this space for describing your block.</p></div></div></div></div></div>',
					attributes: {
						design: 'plain',
						columns: 1,
						reverseTitle: false,
						alignment: 'center',
						showColumnRule: false,
						showTitle: false,
						titleLineHeightUnit: 'em',
						titleTabletLineHeightUnit: 'em',
						titleMobileLineHeightUnit: 'em',
						showSubtitle: false,
						subtitleLineHeightUnit: 'em',
						subtitleTabletLineHeightUnit: 'em',
						subtitleMobileLineHeightUnit: 'em',
						subtitleOnTop: false,
						text1: 'Description for this block. Use this space for describing your block. Any text will do. Description for this block. You can use this space for describing your block.',
						textLineHeightUnit: 'em',
						textTabletLineHeightUnit: 'em',
						textMobileLineHeightUnit: 'em',
						uniqueClass: 'ugb-6e7c623',
						hideDesktop: false,
						hideTablet: false,
						hideMobile: false,
						showBlockBackground: false,
						blockBackgroundBackgroundCustomSizeUnit: '%',
						blockBackgroundTabletBackgroundCustomSizeUnit: '%',
						blockBackgroundMobileBackgroundCustomSizeUnit: '%',
						topSeparatorDesign: 'wave-1',
						bottomSeparatorDesign: 'wave-1',
						topSeparatorShadow: true,
						bottomSeparatorShadow: true,
					},
				},
			],
		},
	],
}
